/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Strategy to use when resuming consumption of notifications.
 * @export
 */
export const ResumeStrategy = {
    Continue: 'CONTINUE',
    Latest: 'LATEST',
    Earliest: 'EARLIEST',
    FromTimestamp: 'FROM_TIMESTAMP'
} as const;
export type ResumeStrategy = typeof ResumeStrategy[keyof typeof ResumeStrategy];


export function instanceOfResumeStrategy(value: any): boolean {
    for (const key in ResumeStrategy) {
        if (Object.prototype.hasOwnProperty.call(ResumeStrategy, key)) {
            if (ResumeStrategy[key as keyof typeof ResumeStrategy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResumeStrategyFromJSON(json: any): ResumeStrategy {
    return ResumeStrategyFromJSONTyped(json, false);
}

export function ResumeStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResumeStrategy {
    return json as ResumeStrategy;
}

export function ResumeStrategyToJSON(value?: ResumeStrategy | null): any {
    return value as any;
}

export function ResumeStrategyToJSONTyped(value: any, ignoreDiscriminator: boolean): ResumeStrategy {
    return value as ResumeStrategy;
}

